(function () {
  'use strict';

  // ---------- Lightbox: ein global Overlay-Element wird von der Section gerendert ----------
  var lightbox = null;
  var lightboxFrame = null;
  var lastFocus = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.querySelector('[data-ergotec-lightbox]');
    if (!lightbox) return null;
    lightboxFrame = lightbox.querySelector('iframe');
    var closeBtn = lightbox.querySelector('[data-ergotec-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
        closeLightbox();
      }
    });
    return lightbox;
  }

  function openLightbox(ytId) {
    var lb = ensureLightbox();
    if (!lb || !ytId) return;
    lastFocus = document.activeElement;
    var src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(ytId) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    lightboxFrame.setAttribute('src', src);
    lb.classList.add('is-open');
    lb.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var closeBtn = lb.querySelector('[data-ergotec-lightbox-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('hidden', '');
    if (lightboxFrame) lightboxFrame.setAttribute('src', '');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Click-Handler für alle Video-Cards mit data-yt-id
  function bindVideoTriggers(scope) {
    var triggers = (scope || document).querySelectorAll('[data-yt-id]');
    triggers.forEach(function (el) {
      if (el.__ergotecBound) return;
      el.__ergotecBound = true;
      el.addEventListener('click', function (e) {
        var ytId = el.getAttribute('data-yt-id');
        if (!ytId) return;
        e.preventDefault();
        openLightbox(ytId);
      });
    });
  }

  // ---------- Karussell ----------
  function getSlideStep(track) {
    var slide = track.querySelector('.ergotec-carousel__slide');
    if (!slide) return track.clientWidth;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateNavState(carousel) {
    var track = carousel.querySelector('.ergotec-carousel__track');
    var prev = carousel.querySelector('[data-ergotec-carousel-prev]');
    var next = carousel.querySelector('[data-ergotec-carousel-next]');
    if (!track) return;
    var atStart = track.scrollLeft <= 4;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    if (prev) prev.toggleAttribute('disabled', atStart);
    if (next) next.toggleAttribute('disabled', atEnd);
    var hasOverflow = track.scrollWidth > track.clientWidth + 4;
    carousel.classList.toggle('ergotec-carousel--overflow', hasOverflow);
    if (prev) prev.style.display = hasOverflow ? '' : 'none';
    if (next) next.style.display = hasOverflow ? '' : 'none';
  }

  function initCarousel(carousel) {
    var track = carousel.querySelector('.ergotec-carousel__track');
    var prev = carousel.querySelector('[data-ergotec-carousel-prev]');
    var next = carousel.querySelector('[data-ergotec-carousel-next]');
    if (!track) return;
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -getSlideStep(track), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: getSlideStep(track), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', function () { updateNavState(carousel); }, { passive: true });
    window.addEventListener('resize', function () { updateNavState(carousel); }, { passive: true });
    setTimeout(function () { updateNavState(carousel); }, 50);
  }

  function init() {
    bindVideoTriggers(document);
    document.querySelectorAll('[data-ergotec-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
